import { Injectable } from '@angular/core';

@Injectable()
export class ProgressionService {
  getInformationChampsObligatoires<T>(champsObligatoires: ChampObligatoire<T>[], object: T, data: any): InformationChampsObligatoires<T> {
    let champsObligatoiresManquants: ChampObligatoire<T>[] = [];
    champsObligatoires.forEach(champObligatoire => {
      if (!champObligatoire.check(object, data)) {
        champsObligatoiresManquants.push(champObligatoire);
      }
    });
    return {
      champsObligatoiresManquants: champsObligatoiresManquants,
      countOk: champsObligatoires.length - champsObligatoiresManquants.length,
      countKo: champsObligatoiresManquants.length,
      countTotal: champsObligatoires.length,
      valueCompletion: Math.round(((champsObligatoires.length - champsObligatoiresManquants.length) * 100) / champsObligatoires.length),
    };
  }

  getProgresssBarColorClass = (value: number) => (value == null || value == undefined || Number.isNaN(value) ? '' : value < 50 ? 'progress-bar-danger' : value < 80 ? 'progress-bar-warning' : value >= 80 ? 'progress-bar-success' : '');

  getProgresssColorClass = (value: number, prefixe: string) => (value == null || value == undefined || Number.isNaN(value) ? '' : value < 50 ? prefixe + 'danger' : value < 80 ? prefixe + 'warning' : value >= 80 ? prefixe + 'success' : '');
}

export interface ChampObligatoire<T> {
  key: string;
  tab?: string;
  tabIndex?: number;
  collapseIndex?: number;
  collapseGroupeIndex?: number;
  id?: string;
  check?: (T, any?) => boolean;
  message: string;
  champ?: string;
  idQuestion?: number;
}

export interface InformationChampsObligatoires<T> {
  champsObligatoiresManquants: ChampObligatoire<T>[];
  valueCompletion: number;
  countOk: number;
  countKo: number;
  countTotal: number;
}
